// animeTrigger: 特定のスクロール位置で対象にアニメーションクラス付与
export default function animeTrigger() {
  var $target = $('.js-fade-item');
  if(!$target[0]) return;

  var targetInfo = [];
  var startPos = $(window).height() * .8;

  // 各アイテムの情報入力
  $target.each(function (index, el) {
    var thisObj = {};
    thisObj['selector'] = $(this);
    thisObj['pos'] = $(this).get(0).offsetTop - startPos;
    targetInfo.push(thisObj);
  });
  // 関数の呼び出し
  effectStart();
  $(window).on('scroll', effectStart);

  function effectStart() {
    var currentPos =
      document.documentElement.scrollTop || // IE、Firefox、Opera
      document.body.scrollTop;              // Chrome、Safari
    for (var i = 0; i < targetInfo.length; i++) {
      if (targetInfo[i].pos <= currentPos) {
        targetInfo[i].selector.addClass('is-effect');
      }
    }
  }
}



// WEBPACK FOOTER //
// ./js/module/animeTrigger.js